import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-receipts',
  templateUrl: './receipts.component.html',
  styleUrls: ['./receipts.component.scss']
})
export class ReceiptsComponent implements OnInit {

  constructor() { }
  modeSelected: boolean;
  
  ngOnInit() {
    this.modeSelected = false;
  }
  onModeSelected(type) {

    this.modeSelected = true;
  }

}
